import Header from './components/header/header'
import i18n from './components/language-switcher/i18n'
import { I18nextProvider } from 'react-i18next'
import AOS from 'aos';
import 'aos/dist/aos.css';
import {useEffect} from "react";
import TableBlock from "./components/table-block/table-block";
import MainBlock from "./components/main-block/main-block";
import InfoBlock from "./components/info-block/info-block";
import PriceBlock from "./components/price-block/price-block";
import InfoBlock2 from "./components/info-block-2/info-block-2";
import InfoBlock3 from "./components/info-block-3/info-block-3";
import ContactBlock from "./components/contact-block/contact-block";
import Footer from "./components/footer/footer";

function App() {

    useEffect(() => {
        AOS.init({ duration: 1000 }); // Настройка длительности анимации
    }, []);

    return (
        <I18nextProvider i18n={i18n}>
            <div className='main-bg'>
                <Header />
                <MainBlock />
            </div>
            <InfoBlock />
            <PriceBlock />
            <InfoBlock2 />
            <TableBlock />
            <InfoBlock3 />
            <ContactBlock />
            <Footer />

        </I18nextProvider>
    )
}

export default App
